import { Controller } from "@hotwired/stimulus"

// Opens the modal a direct visit asked for (see render_page_or_open_modal). The link is used once and removed,
// so a Turbo cache restore of this page does not open the modal again.
export default class extends Controller {
  connect() {
    this.element.click()
    this.element.remove()
  }
}
